import InputField from "components/fields/InputField";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { _forgotPassword } from "Services/api";
import {
  ForgotPasswordFormFieldsName,
  forgotPasswordFormDefaultValues,
  forgotPasswordFormSchema,
} from "constants/react-hook-form";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const { control, handleSubmit, setError } = useForm({
    resolver: zodResolver(forgotPasswordFormSchema),
    defaultValues: forgotPasswordFormDefaultValues,
  });

  const handleVendorForgotPassword = async (data) => {
    // Reset errors and message
    setMessage("");

    setLoading(true);

    try {
      const response = await _forgotPassword({
        body: { email: data[ForgotPasswordFormFieldsName.EMAIL] },
      });

      if (response.success) {
        setMessage("Password reset email sent successfully!");
      } else {
        setError(ForgotPasswordFormFieldsName.EMAIL, {
          message: response.message || "Failed to send email",
        });
      }
    } catch (error) {
      setError(ForgotPasswordFormFieldsName.EMAIL, {
        message: error.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <span className="loader"></span>
        </div>
      )}

      {/* Forgot Password Section */}
      <form
        className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]"
        onSubmit={handleSubmit(handleVendorForgotPassword)}
        noValidate
      >
        <h4 className="mb-2.5 mt-5 text-4xl font-bold text-navy-700 dark:text-white">
          Forgot Password
        </h4>

        {/* Success Message */}
        {message && <div className="mb-4 text-sm text-green-600">{message}</div>}

        <InputField
          control={control}
          name={ForgotPasswordFormFieldsName.EMAIL}
          variant="auth"
          extra="mb-3"
          label="Enter your registered email"
          placeholder="mail@mail.com"
          id="email"
          type="text"
        />

        <button
          type="submit"
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Send mail
        </button>

        <div className="mt-4">
          <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
            Already registered?
          </span>
          <Link
            to="/admin/auth/sign-in"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Login
          </Link>
        </div>
      </form>
    </div>
  );
}
